module.exports = __webpack_public_path__ + "static/media/benefits-members.b7b5d142.svg";